// Disclaimer: this component can be splitted according to the need of futur developments
//  So all sections values will be managed by redux-form
import * as React from 'react';
import { useTranslator, mapTags } from '@gandi/translate';
import { Base, Block, BlockHeading, BlockContent } from '@gandi/ui';
import { DisabledContext } from '../../formUtils/DisabledContext';
import { useFormInitialValues } from '../../formUtils/useFormInitialValues';
import AddSectionButton from './components/AddSectionButton';
import MailboxesSection from './components/MailboxesSection';
import NameserversSection from './components/NameserversSection';
import WebForwardsSection from './components/WebForwardsSection';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "addSectionButton": "SectionsEditor-addSectionButton_1kgk8"
};
const SECTION_NS = 'nsAndRecords';
const SECTION_FORWARDS = 'webForwards';
const SECTION_MAILBOXES = 'mailboxes';
const SECTION_COMPONENTS = {
  nsAndRecords: NameserversSection,
  webForwards: WebForwardsSection,
  mailboxes: MailboxesSection
};
const SECTION_KEYS = Object.keys(SECTION_COMPONENTS);
const SectionsEditor = baseProps => {
  const {
    __
  } = useTranslator();
  const initialValues = useFormInitialValues();
  const {
    disabled
  } = React.useContext(DisabledContext);
  const existingSectionKeys = SECTION_KEYS.filter(key => !!initialValues?.[key]);
  const [sections, setSection] = React.useState(existingSectionKeys);

  // the sections appears in the order of the user add its
  const addSection = sectionType => setSection([...sections, sectionType]);
  const removeSection = sectionType => setSection(sections.filter(section => section !== sectionType));
  const displaySectionSelector = !disabled && sections.length < SECTION_KEYS.length;
  return /*#__PURE__*/_jsxs(Base, {
    ...baseProps,
    children: [sections.map((sectionType, index) => {
      const Comp = SECTION_COMPONENTS[sectionType];
      return /*#__PURE__*/_jsx(Comp, {
        onDelete: () => removeSection(sectionType),
        disabled: disabled,
        marginBottom:
        // display margin when not last or if section selector is visible
        displaySectionSelector || index < sections.length - 1 ? 'base' : undefined
      }, sectionType);
    }), displaySectionSelector && /*#__PURE__*/_jsxs(Block, {
      children: [/*#__PURE__*/_jsx(BlockHeading, {
        children: __('Add section to your configuration')
      }), /*#__PURE__*/_jsx(BlockContent, {
        children: /*#__PURE__*/_jsxs(Base, {
          flex: true,
          flexWrap: true,
          children: [!sections.includes(SECTION_NS) && /*#__PURE__*/_jsxs(AddSectionButton, {
            type: "button",
            className: styles.addSectionButton,
            onClick: () => addSection(SECTION_NS),
            children: [/*#__PURE__*/_jsx("span", {
              "aria-hidden": true,
              children: "+ "
            }), mapTags(__('[[add:Add]][[section:Nameservers & DNS records]]'), ({
              add,
              section
            }) => ({
              add: /*#__PURE__*/_jsx("span", {
                children: add
              }),
              section: /*#__PURE__*/_jsx(Base, {
                tagName: "span",
                display: "block",
                children: section
              })
            }))]
          }), !sections.includes(SECTION_FORWARDS) && /*#__PURE__*/_jsxs(AddSectionButton, {
            type: "button",
            className: styles.addSectionButton,
            onClick: () => addSection(SECTION_FORWARDS),
            children: [/*#__PURE__*/_jsx("span", {
              "aria-hidden": true,
              children: "+ "
            }), mapTags(__('[[add:Add]][[section: Web forwarding]]'), ({
              add,
              section
            }) => ({
              add: /*#__PURE__*/_jsx("span", {
                children: add
              }),
              section: /*#__PURE__*/_jsx(Base, {
                tagName: "span",
                display: "block",
                children: section
              })
            }))]
          }), !sections.includes(SECTION_MAILBOXES) && /*#__PURE__*/_jsxs(AddSectionButton, {
            type: "button",
            className: styles.addSectionButton,
            onClick: () => addSection(SECTION_MAILBOXES),
            children: [/*#__PURE__*/_jsx("span", {
              "aria-hidden": true,
              children: "+ "
            }), mapTags(__('[[add:Add]][[section: Mailbox]]'), ({
              add,
              section
            }) => ({
              add: /*#__PURE__*/_jsx("span", {
                children: add
              }),
              section: /*#__PURE__*/_jsx(Base, {
                tagName: "span",
                display: "block",
                children: section
              })
            }))]
          })]
        })
      })]
    })]
  });
};
export default SectionsEditor;